import { CSSProperties } from 'react';

export interface PublicComponentProps {
  /**
   * Class name to be applied on the root element
   */
  className?: string;

  /**
   * Inline styles to be applied on the root element
   */
  style?: CSSProperties;

  /**
   * Data attribute for testing to be applied on the root element
   */
  'data-testid'?: string;
}
